<template>
  <div class="home" style="margin-top: -20rem; margin-right: 18rem">
    <div class="flex container">
      <div
        style="width: 62%; margin-left: 18rem; margin-top: -4rem"
        class="..."
      >
        <header class="text-gray-600 body-font">
          <div
            class="
              mx-auto
              flex flex-wrap
              p-1
              mb-5
              flex-col
              md:flex-row
              items-center
            "
          >
            <nav
              class="flex lg:w-2/5 flex-wrap items-center text-base md:ml-auto"
            >
              <a class="mr-5 text-blue-400" style="border-bottom: 1px solid">
                English
              </a>
              <a class="mr-5 hover:text-gray-900">French</a>
              <a class="mr-5 hover:text-gray-900">Deutch</a>
              <a class="hover:text-gray-900">Spanish</a>
            </nav>

            <div class="lg:w-2/5 inline-flex lg:justify-end ml-5 lg:ml-0">
              <button
                class="
                  inline-flex
                  items-center
                  bg-gray-100
                  border-10
                  py-3
                  px-5
                  focus:outline-none
                  hover:bg-gray-200
                  rounded
                  text-base
                  mt-4
                  md:mt-0
                "
              >
                + Add
              </button>
            </div>
          </div>
        </header>
        <div class="content">
          <h1
            class="
              text-left
              mt-10
              font-bold
              title-font
              sm:text-4xl
              text-3xl
              mb-4
              font-medium
              text-gray-900
            "
          >
            <span class="mr-4" style="color: lightgrey">1</span>
            Abbesses Metro Station
          </h1>

          <p class="mb-8 text-left mt-8 leading-relaxed">
            Copper mug try-hard pitchfork pour-over freegan heirloom neutra air
            plant cold-pressed tacos poke beard tote bag. Heirloom echo park
            mlkshk tote bag selvage hot chicken authentic tumeric truffaut
            hexagon try-hard chambray.
          </p>
        </div>
        <hr />
        <br />
        <br />
        <div class="flex justify-between">
          <div class="content text-txt font-semibold text-2xl">Location</div>
          <div class="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-6 h-6"
              fill="#2daee1"
              viewBox="0 0 384 512"
            >
              <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
              <path
                d="M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM192 256C227.3 256 256 227.3 256 192C256 156.7 227.3 128 192 128C156.7 128 128 156.7 128 192C128 227.3 156.7 256 192 256z"
              />
            </svg>
          </div>
        </div>
        <br />
        <div
          class="flex flex-wrap w-full bg-gray-100 py-32 px-10 relative mb-4"
        >
          <img
            alt="gallery"
            class="
              w-full
              object-cover
              h-full
              object-center
              block
              absolute
              inset-0
            "
            src="../assets/map.png"
          />
          <div class="text-center relative z-10 w-full">
            <a
              style="position: absolute; top: 5rem; left: 0px"
              class="mt text-white inline-flex text-left"
            >
              <svg
                fill="White"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                class="w-8 h-6 ml-1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  d="M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"
                />
              </svg>
              Set Cover
            </a>
          </div>
        </div>
        <br />
        <br />

        <div class="tags flex justify-between">
          <h1
            class="
              text-left
              font-bold
              title-font
              sm:text-3xl
              text-2xl
              mb-4
              font-medium
              text-gray-900
            "
          >
            Audio
          </h1>
          <div class="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-6 h-6"
              fill="#2daee1"
              viewBox="0 0 384 512"
            >
              <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
              <path
                d="M192 352c53.03 0 96-42.97 96-96v-160c0-53.03-42.97-96-96-96s-96 42.97-96 96v160C96 309 138.1 352 192 352zM344 192C330.7 192 320 202.7 320 215.1V256c0 73.33-61.97 132.4-136.3 127.7c-66.08-4.169-119.7-66.59-119.7-132.8L64 215.1C64 202.7 53.25 192 40 192S16 202.7 16 215.1v32.15c0 89.66 63.97 169.6 152 181.7V464H128c-18.19 0-32.84 15.18-31.96 33.57C96.43 505.8 103.8 512 112 512h160c8.222 0 15.57-6.216 15.96-14.43C288.8 479.2 274.2 464 256 464h-40v-33.77C301.7 418.5 368 344.9 368 256V215.1C368 202.7 357.3 192 344 192z"
              />
            </svg>
          </div>
        </div>

        <section class="audio flex jsutify-between">
          <div class="content">
            <h2
              class="
                text-xl
                tracking-widest
                font-medium
                title-font
                text-left
                mb-1
              "
            >
              Some Recording
            </h2>
            <h1 class="text-md font-medium title-font text-gray-500">
              15-19 Place Saint-Pierre, Paris - 17 Dec, 13:45
            </h1>
          </div>

          <div class="data ml-auto">
            <button
              class="
                inline-flex
                py-3
                px-5
                rounded-lg
                items-center
                hover:bg-gray-200
                focus:outline-none
              "
            >
              <span class="ml-4 flex items-start flex-col leading-none">
                <span class="text-xs text-gray-600 mb-1">13:24</span>
              </span>
            </button>
            <button
              class="
                inline-flex
                py-3
                px-5
                rounded-lg
                items-center
                hover:bg-gray-200
                focus:outline-none
              "
            >
              <span class="ml-4 flex items-start flex-col leading-none">
                <span class="text-xs text-gray-600 mb-1 font-semibold">
                  . . .
                </span>
              </span>
            </button>
          </div>
        </section>
        <br />
        <hr />
        <br />
        <section class="audio flex jsutify-between">
          <div class="content">
            <h2
              class="
                text-xl
                tracking-widest
                font-medium
                title-font
                text-left
                mb-1
              "
            >
              Some Recording
            </h2>
            <h1 class="text-md font-medium title-font text-gray-500">
              15-19 Place Saint-Pierre, Paris - 17 Dec, 13:45
            </h1>
          </div>

          <br />

          <div class="data ml-auto">
            <button
              class="
                inline-flex
                py-3
                px-5
                rounded-lg
                items-center
                hover:bg-gray-200
                focus:outline-none
              "
            >
              <span class="ml-4 flex items-start flex-col leading-none">
                <span class="text-xs text-gray-600 mb-1">13:24</span>
              </span>
            </button>
            <button
              class="
                inline-flex
                py-3
                px-5
                rounded-lg
                items-center
                hover:bg-gray-200
                focus:outline-none
              "
            >
              <span class="ml-4 flex items-start flex-col leading-none">
                <span class="text-xs text-gray-600 mb-1 font-semibold">
                  . . .
                </span>
              </span>
            </button>
          </div>
        </section>

        <br />
        <hr />
        <br />
        <div class="photo flex justify-between">
          <h1
            class="
              text-left
              font-bold
              title-font
              sm:text-3xl
              text-2xl
              mb-4
              font-medium
              text-gray-900
            "
          >
            Photo
          </h1>
          <div class="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-6 h-6"
              fill="#2daee1"
              viewBox="0 0 384 512"
            >
              <path
                d="M194.6 32H317.4C338.1 32 356.4 45.22 362.9 64.82L373.3 96H448C483.3 96 512 124.7 512 160V416C512 451.3 483.3 480 448 480H64C28.65 480 0 451.3 0 416V160C0 124.7 28.65 96 64 96H138.7L149.1 64.82C155.6 45.22 173.9 32 194.6 32H194.6zM256 384C309 384 352 341 352 288C352 234.1 309 192 256 192C202.1 192 160 234.1 160 288C160 341 202.1 384 256 384z"
              />
            </svg>
          </div>
        </div>

        <div class="py-20 mx-auto">
          <div class="flex flex-wrap -m-4">
            <div class="p-4 md:w-1/3">
              <div
                class="
                  h-full
                  border-2 border-gray-200 border-opacity-60
                  rounded-lg
                  overflow-hidden
                "
              >
                <img
                  class="lg:h-48 md:h-36 w-full object-cover object-center"
                  src="https://media.istockphoto.com/photos/eiffel-tower-in-paris-skyline-at-dawn-picture-id1280246120?b=1&k=20&m=1280246120&s=170667a&w=0&h=9g8hb-FTp7TfrN6gItpxDFKG0wPjwvnZQlNHZaxyeeI="
                  alt="blog"
                />
              </div>
            </div>
            <div class="p-4 md:w-1/3">
              <div
                class="
                  h-full
                  border-2 border-gray-200 border-opacity-60
                  rounded-lg
                  overflow-hidden
                "
              >
                <img
                  class="lg:h-48 md:h-36 w-full object-cover object-center"
                  src="https://media.istockphoto.com/photos/arc-de-triomphe-from-the-sky-paris-picture-id1324189687?b=1&k=20&m=1324189687&s=170667a&w=0&h=FfUeOeb0NB-sbrNCiu4zCmhsnqCK0nx40D-fY1UFMKM="
                  alt="blog"
                />
              </div>
            </div>
            <div class="p-4 md:w-1/3">
              <div
                class="
                  h-full
                  border-2 border-gray-200 border-opacity-60
                  rounded-lg
                  overflow-hidden
                "
              >
                <img
                  class="lg:h-48 md:h-36 w-full object-cover object-center"
                  src="https://media.istockphoto.com/photos/paris-aerial-panorama-with-river-seine-and-eiffel-tower-france-picture-id1336449613?b=1&k=20&m=1336449613&s=170667a&w=0&h=atFJsGNEMuHaPll6bRwOkZl8Q0Iz83EcUUi0SvhAeM8="
                  alt="blog"
                />
              </div>
            </div>
          </div>
        </div>

        <hr />
        <br />
        <div class="tips flex justify-between">
          <h1
            class="
              text-left
              font-bold
              title-font
              sm:text-3xl
              text-2xl
              mb-4
              font-medium
              text-gray-900
            "
          >
            Tips
          </h1>
          <div class="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-6 h-6"
              fill="#2daee1"
              viewBox="0 0 384 512"
            >
              <path
                d="M16 96C16 69.49 37.49 48 64 48C90.51 48 112 69.49 112 96C112 122.5 90.51 144 64 144C37.49 144 16 122.5 16 96zM480 64C497.7 64 512 78.33 512 96C512 113.7 497.7 128 480 128H192C174.3 128 160 113.7 160 96C160 78.33 174.3 64 192 64H480zM480 224C497.7 224 512 238.3 512 256C512 273.7 497.7 288 480 288H192C174.3 288 160 273.7 160 256C160 238.3 174.3 224 192 224H480zM480 384C497.7 384 512 398.3 512 416C512 433.7 497.7 448 480 448H192C174.3 448 160 433.7 160 416C160 398.3 174.3 384 192 384H480zM16 416C16 389.5 37.49 368 64 368C90.51 368 112 389.5 112 416C112 442.5 90.51 464 64 464C37.49 464 16 442.5 16 416zM112 256C112 282.5 90.51 304 64 304C37.49 304 16 282.5 16 256C16 229.5 37.49 208 64 208C90.51 208 112 229.5 112 256z"
              />
            </svg>
          </div>
        </div>
        <div class="tips">
          <ul class="text-left p-3" style="list-style-type: disc">
            <li>Bring a lot of water</li>
            <li>Very crowded on weekends and holidays</li>
            <li>Look for ancient carving on the main door</li>
          </ul>
        </div>

        <hr />
        <br />
        <div class="links flex justify-between">
          <h1
            class="
              text-left
              font-bold
              title-font
              sm:text-3xl
              text-2xl
              mb-4
              font-medium
              text-gray-900
            "
          >
            Links
          </h1>
          <div class="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-10 h-6 mr-2"
              fill="#2daee1"
              viewBox="0 0 384 512"
            >
              <path
                d="M172.5 131.1C228.1 75.51 320.5 75.51 376.1 131.1C426.1 181.1 433.5 260.8 392.4 318.3L391.3 319.9C381 334.2 361 337.6 346.7 327.3C332.3 317 328.9 297 339.2 282.7L340.3 281.1C363.2 249 359.6 205.1 331.7 177.2C300.3 145.8 249.2 145.8 217.7 177.2L105.5 289.5C73.99 320.1 73.99 372 105.5 403.5C133.3 431.4 177.3 435 209.3 412.1L210.9 410.1C225.3 400.7 245.3 404 255.5 418.4C265.8 432.8 262.5 452.8 248.1 463.1L246.5 464.2C188.1 505.3 110.2 498.7 60.21 448.8C3.741 392.3 3.741 300.7 60.21 244.3L172.5 131.1zM467.5 380C411 436.5 319.5 436.5 263 380C213 330 206.5 251.2 247.6 193.7L248.7 192.1C258.1 177.8 278.1 174.4 293.3 184.7C307.7 194.1 311.1 214.1 300.8 229.3L299.7 230.9C276.8 262.1 280.4 306.9 308.3 334.8C339.7 366.2 390.8 366.2 422.3 334.8L534.5 222.5C566 191 566 139.1 534.5 108.5C506.7 80.63 462.7 76.99 430.7 99.9L429.1 101C414.7 111.3 394.7 107.1 384.5 93.58C374.2 79.2 377.5 59.21 391.9 48.94L393.5 47.82C451 6.731 529.8 13.25 579.8 63.24C636.3 119.7 636.3 211.3 579.8 267.7L467.5 380z"
              />
            </svg>
          </div>
        </div>
        <br />

        <div class="links flex">
          <div class="p-4 md:w-1/3">
            <div
              class="
                h-full
                border-2 border-gray-200 border-opacity-60
                rounded-lg
                overflow-hidden
              "
            >
              <img
                class="lg:h-48 md:h-36 w-full object-cover object-center"
                src="https://media.istockphoto.com/photos/eiffel-tower-in-paris-skyline-at-dawn-picture-id1280246120?b=1&k=20&m=1280246120&s=170667a&w=0&h=9g8hb-FTp7TfrN6gItpxDFKG0wPjwvnZQlNHZaxyeeI="
                alt="blog"
              />
              <div class="text-left p-6">
                <h1 class="title-font text-lg font-medium text-gray-900 mb-3">
                  The Catalyzer
                </h1>
                <p class="leading-relaxed mb-3">
                  Photo booth fam kinfolk cold-pressed sriracha leggings
                  jianbing microdosing tousled waistcoat.
                </p>
                <h2
                  class="
                    tracking-widest
                    text-xs
                    title-font
                    font-medium
                    text-gray-400
                    mb-1
                  "
                >
                  URL
                </h2>
              </div>
            </div>
          </div>
          <div class="p-4 md:w-1/3">
            <div
              class="
                h-full
                border-2 border-gray-200 border-opacity-60
                rounded-lg
                overflow-hidden
              "
            >
              <img
                class="lg:h-48 md:h-36 w-full object-cover object-center"
                src="https://media.istockphoto.com/photos/eiffel-tower-in-paris-skyline-at-dawn-picture-id1280246120?b=1&k=20&m=1280246120&s=170667a&w=0&h=9g8hb-FTp7TfrN6gItpxDFKG0wPjwvnZQlNHZaxyeeI="
                alt="blog"
              />
              <div class="text-left p-6">
                <h1 class="title-font text-lg font-medium text-gray-900 mb-3">
                  Title
                </h1>
                <p class="leading-relaxed mb-3">Description</p>
                <h2
                  class="
                    tracking-widest
                    text-xs
                    title-font
                    font-medium
                    text-gray-400
                    mb-1
                  "
                >
                  URL
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { collapsed, toggleSidebar } from '@/components/sidebar/state'

// export default {
//   setup() {
//     return { collapsed, toggleSidebar }
//   }
// }
</script>
